/* istanbul ignore file */

import React from 'react';
import { VisibilityTrackerContainer } from '@noths/polaris-client-components';
import {
  ClickCarouselLinkPayload,
  PillBarCarousel,
} from '@noths/polaris-client-ribbons-design-system';
import { Link } from '@noths/polaris-dev-ts-types';

import { EventCategory, FilterOptionValue, SelectedFilterOption } from 'src/types';
import { FilterUid } from '../../constants/uids';
import * as styles from '../../styles/QuickFilters.styles';

const QUICK_FILTERS_VISIBILITY_THRESHOLD = 0.7;

const addOrRemove = <T,>(array: T[], item: T) =>
  array.includes(item) ? array.filter((c) => c !== item) : [...array, item];

export interface QuickFiltersProps {
  id: string;
  title: string;
  filterUid: FilterUid;
  filterLinks?: Link[];
  selectedFilterOptions?: string | number | FilterOptionValue[];
  onSelectFilterOption?: (selectedFilterOption: SelectedFilterOption) => void;
}

export const QuickFilters = ({
  id,
  title,
  filterUid,
  filterLinks,
  selectedFilterOptions = [],
  onSelectFilterOption,
}: QuickFiltersProps) => {
  const handleLinkClick = ({ link: { href: optionValue } }: ClickCarouselLinkPayload) => {
    if (!optionValue) return;

    const filterOptionValue = Array.isArray(selectedFilterOptions)
      ? addOrRemove(selectedFilterOptions, optionValue)
      : optionValue;

    onSelectFilterOption?.({
      filterUid,
      filterOptionValue,
      eventCategory: EventCategory.QuickFilters,
    });
  };

  if (!filterLinks) return null;

  return (
    <VisibilityTrackerContainer sectionName={id} threshold={QUICK_FILTERS_VISIBILITY_THRESHOLD}>
      <div css={styles.quickFilters}>
        <PillBarCarousel
          id={id}
          title={title}
          carouselType={filterUid}
          activeLinks={selectedFilterOptions}
          links={filterLinks}
          onLinkClick={handleLinkClick}
        />
      </div>
    </VisibilityTrackerContainer>
  );
};
